import "@/styles/globals.css";
import { useApollo } from "@neonjungle/headless";
import { ApolloProvider } from "@apollo/client";
import type { AppProps } from "next/app";
import localFont from "next/font/local";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DotLottieReact as Player } from "@lottiefiles/dotlottie-react";

const alliance = localFont({
	src: "../fonts/AllianceNo.2-Medium.otf",
	variable: "--font-alliance",
	display: "swap",
});

export default function App({ Component, pageProps }: AppProps) {
	const apolloClient = useApollo(pageProps);
	const [showOverlay, setShowOverlay] = useState(true);
	const [lottie, setLottie] = useState(null);

	const dotLottieRefCallback = (lottie: any) => {
		setLottie(lottie);
		lottie?.addEventListener("complete", () => {
			setShowOverlay(false);
		});
	};

	return (
		<ApolloProvider client={apolloClient}>
			<div
				className={`${alliance.variable} grid-cols-[80px_1fr] font-sans text-base lg:grid lg:text-lg ${
					showOverlay ? "overflow-hidden" : ""
				}`}
			>
				<AnimatePresence>
					{showOverlay && (
						<motion.div
							initial={{ opacity: 1 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.7, delay: 0.8 }}
							className="bg-beige fixed inset-0 z-50"
						>
							<motion.div
								className="flex size-full items-center"
								initial={{ opacity: 1 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 0.3, delay: 0.3 }}
							>
								<div className="grow">
									<Player autoplay dotLottieRefCallback={dotLottieRefCallback} src="/logo-animation.json" />
								</div>
							</motion.div>
						</motion.div>
					)}
				</AnimatePresence>
				<Component {...pageProps} />
			</div>
		</ApolloProvider>
	);
}
